import React from 'react';
import cn from 'classnames';

interface DangerouslySetInnerHTML {
  __html: string;
}

interface Text {
  children?: React.ReactNode;
  className?: string;
  color?: 'dark' | 'gray-600' | 'light' | 'navy' | 'primary' | 'red' | 'white';
  dangerouslySetInnerHTML?: DangerouslySetInnerHTML;
  direction?: 'rtl';
  fontSize?: 12 | 14 | 24 | 40;
  fontWeight?: 500 | 600;
  isEllipsis?: boolean;
  maxWidth?: '100%';
  style?: React.CSSProperties;
  textAlign?: 'center';
}

const Text = ({
  children,
  className,
  color,
  dangerouslySetInnerHTML,
  direction,
  fontSize,
  fontWeight,
  isEllipsis,
  maxWidth,
  style,
  textAlign,
}: Text) => (
  <p
    className={cn('whatcrm-widget-text', {
      'whatcrm-widget-text_ellipsis': isEllipsis,
      [`${className}`]: className,
      [`whatcrm-widget-text_${color}`]: color,
      [`whatcrm-widget-text_${fontSize}`]: fontSize,
    })}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    style={{ ...style, direction, fontWeight, maxWidth, textAlign }}
  >
    {children}
  </p>
);

export default Text;
